export default __webpack_public_path__ + "static/media/P24NOW.933d837e.png";